import { TextFieldTheme, TextField as TPATextField } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { useTranslation } from '../../../contexts/translation-context';
import { classes } from './year-field-wut.st.css';
export function YearFieldWUT(props) {
    const { id, className, onChange, ...rest } = props;
    const { t } = useTranslation();
    const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
    return /*#__PURE__*/ React.createElement(TPATextField, {
        ...rest,
        type: "text",
        inputMode: "numeric",
        newErrorMessage: true,
        maxLength: 4,
        theme: TextFieldTheme.Box,
        onChange: handleChange,
        "aria-label": t('field.date.placeholder.year'),
        className: classNames(className, classes.root, classes.theme, {
            [classes.hover]: forcedHover
        })
    });
    function handleChange(event) {
        props.onChange?.(event.target.value);
    }
}

//# sourceMappingURL=year-field-wut.js.map